import { Container, Typography } from '@mui/material';
import { t } from 'i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import SignUpForm from 'src/components/form/SignUpForm';

const SignUp = () => {
  return (
    <Container maxWidth="md" sx={{ py: 2, mt: { md: 0, xs: 4 } }}>
      <Helmet>
        <title>Sign Up</title>
      </Helmet>
      <Typography sx={{ my: 5, textAlign: 'center' }} variant="h4" color={'primary'}>
        {t('signupPage.heading')}
      </Typography>
      <SignUpForm />
      <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
        {t('signupPage.haveAccount')}{' '}
        <Link to={'/'} style={{ color: '#ACD644', textDecoration: 'none' }}>
          {t('signupPage.signin')}
        </Link>
      </Typography>
    </Container>
  );
};

export default SignUp;
